// https://govuk-elements.herokuapp.com/data/
import styled from 'react-emotion';
var TableHeader = styled('thead')({
  // TODO: avoid cascade
  ' th': {
    fontWeight: 700
  }
});
export default TableHeader;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/table/es/atoms/TableHeader/index.js
// module id = 122
// module chunks = 0